import { ChangeEvent } from "react";
import { Pane, TextInputField } from "evergreen-ui";
import { ContentPosition, DetailsPageSection } from "../../common/DetailsPageSection";
import { FooterActionBar } from "../../common/FooterActionBar";
import { PrefixInputField } from "../../common/PrefixInputField";
import { useHistory } from "react-router-dom";
import { useStoreCreateContext } from "./StoreCreateContext";

export const StoreCreateDetailsTab = (): JSX.Element => {
    const history = useHistory();
    const {
        formValues,
        formStatusMessage,
        isFormValid,
        setField,
        submitFormLoading,
        submitFormCalled,
        submitForm,
    } = useStoreCreateContext();

    const handleStoreNameChange = (e: ChangeEvent<HTMLInputElement>): void => {
        setField('storeName', e.target.value);
    };

    const handleTundraSubdomainPrefixChange = (e: ChangeEvent<HTMLInputElement>): void => {
        setField('tundraSubdomainPrefix', e.target.value);
    };

    return <Pane>
        <DetailsPageSection
            hideBorder={true}
            heading={
                <div className="jc-header-wrapper">
                    <h3 className="jc-header-title">Details</h3>
                    <p className="jc-header-required">Required</p>
                </div>
            }
            contentPosition={ContentPosition.left}
        >
            <br />
            {/* This className is required to override the colors for labels and required `*` fields in Evergreen UI components */}
            <div className="jc-create-store-custom-input-colors">
                <TextInputField
                    name={"storeName"}
                    label={"Store Name"}
                    required={true}
                    maxWidth={"620px"}
                    value={formValues.storeName}
                    className="jc-create-store-input"
                    onChange={handleStoreNameChange}
                />
                <PrefixInputField
                    name={"tundraSubdomainPrefix"}
                    label={"Store ID"}
                    required={true}
                    maxWidth={"620px"}
                    suffix={".junipercreates.com"}
                    value={formValues.tundraSubdomainPrefix}
                    className="jc-create-store-input"
                    onChange={handleTundraSubdomainPrefixChange}
                />
            </div>
            <p style={{ margin: 0, lineHeight: '1.7em' }}>In most cases, use the store name with no capitals, spaces, or punctuation.</p>
        </DetailsPageSection>
        <FooterActionBar
            primaryButtonText={"Create Store"}
            isPrimaryLoading={submitFormCalled && submitFormLoading}
            primaryButtonDisabled={!isFormValid || (submitFormCalled && submitFormLoading)}
            onPrimaryClick={submitForm}
            showSecondaryButton={false}
            tertiaryButtonText={"Cancel Setup"}
            onTertiaryClick={() => {
                history.push("/stores");
            }}
            infoComponent={
                <p>{formStatusMessage}</p>
            }
        />
    </Pane >;
}
